import { cva } from '@/styled-system/css';

export const toggleButtonIconRecipe = cva({
  base: {
    transition: {
      _motionReduce: 'none',
      _motionSafe: 'color 200ms ease',
    },
  },
  variants: {
    disabled: {
      true: {},
      false: {},
    },
    loading: {
      true: {
        color: 'transparent.invisible',
      },
      false: {},
    },
    selected: {
      true: {},
      false: {},
    },
  },
  compoundVariants: [
    {
      selected: false,
      disabled: false,
      loading: false,
      css: {
        color: {
          base: 'icon.neutral',
          _groupHover: 'icon.neutral',
          _groupActive: 'icon.neutral',
        },
      },
    },
    {
      selected: false,
      disabled: true,
      loading: false,
      css: {
        color: {
          base: 'icon.neutral',
        },
      },
    },
    {
      selected: true,
      disabled: false,
      loading: false,
      css: {
        color: {
          base: 'icon.neutral',
          _groupHover: 'icon.neutral',
          _groupActive: 'icon.neutral',
        },
      },
    },
    {
      selected: true,
      disabled: true,
      loading: false,
      css: {
        color: {
          base: 'icon.neutral',
        },
      },
    },
  ],
});
